(() => {
  if (customElements.get('sales-timer')) return;
  class SalesTimer extends HTMLElement {
    static parseDeadline(value) {
      const match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})T([01]\d|2[0-3]):([0-5]\d)(?::([0-5]\d))?(Z|[+-](?:0\d|1[0-4]):[0-5]\d)$/);
      if (!match) return NaN;
      const year = Number(match[1]), month = Number(match[2]), day = Number(match[3]);
      if (year < 1970 || month < 1 || month > 12 || day < 1 || day > new Date(Date.UTC(year, month, 0)).getUTCDate()) return NaN;
      return Date.parse(value);
    }
    static countdownParts(deadline, now) {
      if (!Number.isFinite(deadline) || !Number.isFinite(now)) return null;
      const total = Math.max(0, Math.ceil((deadline - now) / 1000));
      return { ended: now >= deadline, days: Math.floor(total / 86400), hours: Math.floor(total % 86400 / 3600), minutes: Math.floor(total % 3600 / 60), seconds: total % 60 };
    }
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected && !this.initialized) this.initialize(); });
    }
    initialize() {
      this.initialized = true;
      this.deadline = this.dataset.enabled === 'true' ? SalesTimer.parseDeadline(this.dataset.deadline) : NaN;
      this.endedAnnounced = false;
      this.onVisibility = () => this.tick();
      document.addEventListener('visibilitychange', this.onVisibility);
      this.tick();
      if (Number.isFinite(this.deadline) && Date.now() < this.deadline) this.interval = window.setInterval(() => this.tick(), 1000);
    }
    restoreAnnouncement() {
      this.querySelector('[data-sales-announcement-style]')?.remove();
      window.dispatchEvent(new Event('resize'));
    }
    publish(state) {
      if (this.publishedState === state) return;
      this.publishedState = state;
      document.dispatchEvent(new CustomEvent('sales:timer-state', { detail: { state, deadline: this.dataset.deadline, sectionId: this.dataset.sectionId } }));
    }
    tick() {
      const state = SalesTimer.countdownParts(this.deadline, Date.now());
      if (!state) {
        this.dataset.state = 'idle';
        this.hidden = true;
        this.restoreAnnouncement();
        this.publish('idle');
        return;
      }
      this.dataset.state = state.ended ? 'ended' : 'active';
      this.hidden = state.ended && this.dataset.afterEnd === 'announcement';
      for (const key of ['days', 'hours', 'minutes', 'seconds']) {
        const node = this.querySelector('[data-' + key + ']');
        if (node) node.textContent = String(state[key]).padStart(2, '0');
      }
      this.querySelectorAll('[data-sales-timer-active]').forEach(node => { node.hidden = state.ended; });
      this.querySelectorAll('[data-sales-timer-ended]').forEach(node => { node.hidden = !state.ended; });
      this.publish(this.dataset.state);
      if (state.ended) {
        window.clearInterval(this.interval);
        if (this.dataset.afterEnd === 'announcement') this.restoreAnnouncement();
        if (!this.endedAnnounced) {
          this.endedAnnounced = true;
          const message = this.querySelector('[data-sales-timer-ended]')?.textContent.trim();
          const status = this.querySelector('[data-sales-status]');
          if (status && message) status.textContent = message;
          document.dispatchEvent(new CustomEvent('sales:ended', { detail: { sectionId: this.dataset.sectionId, deadline: this.dataset.deadline } }));
        }
      }
    }
    disconnectedCallback() {
      window.clearInterval(this.interval);
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
      if (window.Shopify?.designMode) {
        document.dispatchEvent(new CustomEvent('sales:timer-state', { detail: { state: 'idle', deadline: '', sectionId: this.dataset.sectionId } }));
      }
      this.initialized = false;
    }
  }
  customElements.define('sales-timer', SalesTimer);
})();
